import React from 'react';
import $ from "jquery";
import Server from '../../../functions/server';
import Loading from '../../loadings';
import { Dropdown, Button } from 'semantic-ui-react';
import View from './view';
import ViewCreditOrder from './viewCreditOrder';
import Add from './add';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

class CreditNote extends React.Component {

  state = {
    customerOption: [], invoice: [], fullWidth: true, maxWidth: 'xl',
    fromDate: this.props.fromDate,
    toDate: this.props.toDate, 
    selectedCustomer: 0
  }

  componentDidUpdate(props) {
    if (props.fromDate != this.props.fromDate) {
      this.setState({ fromDate: this.props.fromDate })
    }
    if (props.toDate != this.props.toDate) {
      this.setState({ toDate: this.props.toDate })
    }
  }

  componentDidMount() {
    this.getCustomer();
  }

  getCustomer() {
    let context = this;
    context.setState({  load: true, message: 'Getting Customer' })
    $.ajax({
    type: 'POST', url: Server() + 'customer/getallcustomer.php',
    success: function(data) {
        context.setState({ load: false, });
        let customerOption = [];
        try {
            data = JSON.parse(data);
            data.map((c) => {
                customerOption.push({ text: c.id+'->'+c.name, key: c.id+'->'+c.name, value: c.id })
            })
            context.setState({ customerOption, load: false })
        } catch (e) {
            context.setState({ load: false });
        }
    },
    error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
    }
    });
  }

  searchInvoice() {
    if (!this.props.menuPermission.add) {
      alert('You Are Not Allow To Add Credit Notes!!!!');
      return;
    }
    let context = this;
    context.setState({ load: true, message: 'Getting Invoice' })
    $.ajax({
        type: 'POST', data: { 'id': context.state.selectedCustomer, 'fromDate': context.state.fromDate, 'toDate': context.state.toDate },
        url: Server() + 'invoice/getcustomerinvoice.php',
        success: function(data) {
            console.log(data);
            console.log('data');
            try {
                data = JSON.parse(data);
                context.setState({ invoice: data, load: false, openInvoice: true })
            } catch (error) {
                alert('Error1!!!')
                context.setState({ load: false })
            }
        },
        error: function(e) {
            alert('Try again!!')
            context.setState({ load: false });
        }
    });
  }

  selectCustomer = (f, { value }) => {
    this.setState({ selectedCustomer: value })
  }

  onSelect = (key1) => event => {
    let val = event.target.value;
    let value = val.split('->')[0];
    this.setState({ selectedCustomer: value, selecteddropdowncustomer: val })
  }

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  }

  makeIntoDecimal(value) {
    try {
      value = value.toFixed(2);
    } catch (error) {
      value = 0;
    }
    return value;
  }

  convertIntoNumber(value) {
    try {
      value = Number(value);
    } catch (value) {
      value = 0;
    }
    return value;
  }

  render() {
    let i = 1;
    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
        <br/>
        <Button onClick={this.searchInvoice.bind(this)}>Add</Button>

        <Dialog fullWidth={this.state.fullWidth} maxWidth={this.state.maxWidth}  open={this.state.openInvoice}
          onClose={ () => { this.setState({ openInvoice: false }) }} aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">{'Create Credit Note'}</DialogTitle>
          <DialogContent>
            <div style={{margin: '2px'}}>
              <div style={{display: 'flex', marginBottom: '5px'}}>
                <div>
                  <b>From Date</b><br/>
                  <input type="date" id="date" value={this.state.fromDate}
                        onChange={this.handleChange('fromDate')} style={{width: '100%', height: 35 }} />
                </div>
                <div style={{marginLeft: '5px'}}>
                  <b>To Date</b><br/>
                  <input type="date" id="date" value={this.state.toDate} onChange={this.handleChange('toDate')}
                        style={{width: '100%', height: 35 }} />
                </div>
                <div style={{marginLeft: '5px'}}>
                  <b>Select Customer</b><br/>
                  <datalist id="suggestionLedger">
                      {this.state.customerOption.map((y) => {
                          return (<option id='box'>{y.text}</option>)
                      })}
                  </datalist>
                  <input style={{height: 35, width: 250}} onChange={this.onSelect('fromledgerid')} autoComplete="on"
                  list="suggestionLedger" value={this.state.selecteddropdowncustomer} />
                </div>
                <div style={{marginLeft: '5px'}}>
                  <br/>
                  <Button primary onClick={this.searchInvoice.bind(this)}>Submit</Button>
                </div>
              </div>
                

                <table width="100%" id='table'>
                    <tr>
                        <th id="th">Sino</th>
                        <th id="th">Date</th>
                        <th id="th">Invoice Voucher</th>
                        <th id="th">Customer Name</th>
                        <th id="th">Items</th>
                        <th id="th">Total</th>
                        <th id="th">View</th>
                    </tr>
                    {
                        this.state.invoice.map((c) => {
                            let date = c.timestamp.split(' ')[0];
                            date = date.split('-')[2]+'-'+date.split('-')[1]+'-'+date.split('-')[0];
                            return (
                                <tr>
                                    <td>{i++}</td>
                                    <td>{date}</td>
                                    <td>{c.invoice_voucher}</td>
                                    <td>{c.cname}</td>
                                    <td><center>{c.items}</center></td>
                                    <td><div style={{textAlign: 'right'}}>{'Rs. '+this.makeIntoDecimal(this.convertIntoNumber(c.total))}</div></td>
                                    <td><View data={c} /></td>
                                </tr>
                            )
                        })
                    }
                </table>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

export default CreditNote;
